(function () {
    "use strict";

// class TextInputController extends Components.InputBaseController {

// @ngInject
function TextInputControllerCtor(
        $scope, $element, $attrs, $compile, $translate, _, $window) {

    this.constructor.$super.call(this, $scope, $element, $attrs, $compile, $translate, _, $window);

    this.__objectType = 'TextInputController';
    // TODO: Remove after ES6
    this.isRequired = false;
    this.validationError = '';
    this._ = _;
    this.$translate = $translate;
}

// TODO(sean): Remove and replace with Es6
var TextInputController = Class(Components.InputBaseController, {
    constructor: TextInputControllerCtor,

    // $onInit() {
    $onInit: function $onInit() {
        // super.$onInit();
        // super.validate();
        this.constructor.$superp.$onInit.call(this);

        this.textInputVariant = 'text';
        this.cssClass['form-element--text'] = true;

        // Confusing, but this is used to set the initial value of the
        // ng-form HTML element and then after initialization
        // "formName" represents that DOM element.
        //this.formName = `${this.name}Form`;
        this.formName = this.name + 'Form';
    },

    // onChange() {
    onChange: function onChange() {
        // super.onChange();
        // super.validate();
        this.constructor.$superp.onChange.call(this);
        this.constructor.$superp.validate.call(this);
    },

    onBlur: function onChange() {
        // super.onChange();
        // super.validate();
        this.constructor.$superp.onBlur.call(this);
        this.constructor.$superp.validate.call(this);
    },

    // shouldShowError() {
    shouldShowError: function() {
        return (this.validationError !== ''
            && (this.formName[this.name].$dirty
                || this.formName.$$parentForm.$submitted)
        );
    }
});

Components.TextInput = {
    templateUrl: 'angular/app/modules/common/ui_components/form/text_input.html',
    controller: TextInputController,

    // Requiring ngModel is a hack that allows us access to the
    // ng form API ($dirty, $valid, $isSubmitted, etc), while still preserving
    // the essence of a unidirectional data flow (e.g. Container -> form -> inputs)
    require: {
        model: 'ngModel'
    },

    bindings: {
        flavor: '@',
        label: '@',
        maximumLength: '@',
        minimumLength: '@',
        name: '@',
        caption: '@',
        tabIndex: '@',
    }
};

}());